export function getFullPathEnv(envKey: string, path?: string) {
  const env = (window as any).env ?? process.env;

  const apiUrl = env[envKey].replace(/\/+$/g, "");
  const pathSemBarra = path?.replace(/^\/+|\/+$/g, "");

  return [apiUrl, pathSemBarra].join("/");
}
